import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { PlusOutlined, RedoOutlined } from "@ant-design/icons";
import { Button, notification, message, Input, Row, Col, Select } from "antd";
import selectChecks from "../selectors/selectChecks";
import { startRemoveCheck, startRefreshAll } from "../actions/checks";
import { setTextFilter, setGroupFilter } from "../actions/filters";
import Check from "./Check";
import PopUp from "./PopUp";
import AddMonitor from "./AddMonitor";
import EditMonitor from "./EditMonitor";
import DialogBox from "./DialogBox";
import { dashboardUrl } from "../actions/consts/host";
import "../styles/components/check-list.scss";
import PlansPopUp from "./PlansPopUp";

const { Option } = Select;
export class CheckList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addNew: false,
      edit: false,
      editId: undefined,
      isShareDialogShown: false,
      tokenToShare: undefined,
      isFormOpen: false,
      isPlansOpen: false,
    };
  }

  showNotif = (title, text, button) => {
    let key = "1";
    notification.config({
      duration: 10,
      placement: "bottomLeft",
    });
    const args = {
      message: title,
      description: text,
      btn: button,
      key,
    };
    notification.warn(args);
  };

  addMonitor = () => {
    const btn = (
      <Button
        onClick={() => {
          notification.close("1");
          this.setState({ isPlansOpen: true });
        }}
        type="primary"
        size="small"
      >
        Upgrade Plan
      </Button>
    );
    if (this.props.subscriptions) {
      if (
        this.props.checks.length >=
        this.props.subscriptions.MAXIMUM_MONITOR_COUNT
      ) {
        this.showNotif(
          `${this.props.plan_name} Plan`,
          `You can't add more than ${this.props.subscriptions.MAXIMUM_MONITOR_COUNT} monitors`,
          btn
        );
      } else {
        this.setState((prevState) => ({ addNew: !prevState.addNew }));
      }
    }
  };

  onAddClose = () => {
    this.setState((prevState) => ({ addNew: !prevState.addNew }));
  };

  onEdit = (editId) => {
    this.setState((prevState) => ({
      edit: !prevState.edit,
      editId,
    }));
  };

  onShare = (token) => {
    this.setState((prevState) => ({
      isShareDialogShown: !prevState.isShareDialogShown,
      tokenToShare: token,
    }));
  };

  onShareClose = () => {
    this.setState((prevState) => ({
      isShareDialogShown: false,
      tokenToShare: undefined,
    }));
  };

  handleChange = (value) => {
    this.props.setGroupFilter(value);
  };

  onRemove = (check) => {
    if (!check.is_protected) {
      this.props.startRemoveCheck({ id: check.id });
    } else {
      message.warn("You can't delete protected monitors.");
    }
  };

  onEditClose = () => {
    this.setState((prevState) => ({ edit: !this.state.edit }));
  };

  onTextChange = (e) => {
    this.props.setTextFilter(e.target.value);
  };

  print_checks = (checks) => {
    let jsx = [];
    jsx.push(
      checks.map((check) => {
        return (
          <Check
            key={check.id}
            onEdit={this.onEdit}
            onRemove={() => this.onRemove(check)}
            onShare={this.onShare}
            {...check}
            activeCheckId={this.props.activeCheckId}
          />
        );
      })
    );
    return jsx;
  };

  closePlans = () => {
    this.setState({
      isPlansOpen: false,
    });
  };

  render() {
    const hasGroup = this.props.subscriptions
      ? R.has("MONITOR_GROUP", this.props.subscriptions)
      : false;
    return (
      <>
        <div className="check-list">
          <Button
            className="refresh-all"
            type="primary"
            icon={<RedoOutlined />}
            size="large"
            onClick={this.props.startRefreshAll}
          >
            Refresh All Monitors
          </Button>
          <div
            className={`check__filter ${
              this.state.addNew ||
              this.state.edit ||
              this.state.isShareDialogShown
                ? "filter__blur"
                : ""
            }`}
          >
            <Row gutter={32} style={{ width: "110%" }}>
              <Col span={hasGroup ? 12 : 24}>
                <Input
                  type="text"
                  placeholder="Search what you want..."
                  value={this.props.filters.text}
                  onChange={this.onTextChange}
                />
              </Col>
              {hasGroup && (
                <Col span={12}>
                  <Select
                    mode="multiple"
                    style={{ width: "100%" }}
                    placeholder="Select Groups"
                    onChange={this.handleChange}
                  >
                    {this.props.labels.map((el) => (
                      <Option key={el}>{el}</Option>
                    ))}
                  </Select>
                </Col>
              )}
            </Row>
          </div>
          <div
            className={`checks ${
              this.state.addNew ||
              this.state.edit ||
              this.state.isShareDialogShown
                ? "filter__blur"
                : ""
            }`}
          >
            {this.print_checks(this.props.checks)}
          </div>
          <Button
            className="btn-add btn-addNew"
            onClick={this.addMonitor}
            disabled={!this.props.is_verified}
            type="primary"
            shape="round"
            icon={<PlusOutlined />}
            size="large"
          >
            Add Monitor
          </Button>
          <DialogBox
            isShown={this.state.isShareDialogShown}
            data={`${dashboardUrl}/symlink/${this.state.tokenToShare}`}
            title="Share"
            onClose={this.onShareClose}
          />
          {this.state.addNew && (
            <PopUp closePopUp={this.onAddClose} closeOnOutClick={false}>
              <AddMonitor key={"form-add"} />
            </PopUp>
          )}
          {this.state.edit && (
            <PopUp closePopUp={this.onEditClose} closeOnOutClick={false}>
              <EditMonitor id={this.state.editId} key={"form-edit"} />
            </PopUp>
          )}
        </div>
        {this.state.isPlansOpen && (
          <PopUp
            closePopUp={this.closePlans}
            closeOnOutClick={false}
            style={{ zIndex: 50 }}
          >
            <PlansPopUp />
          </PopUp>
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setTextFilter: (text) => dispatch(setTextFilter(text)),
  setGroupFilter: (group) => dispatch(setGroupFilter(group)),
  startRemoveCheck: (id) => dispatch(startRemoveCheck(id)),
  startRefreshAll: () => dispatch(startRefreshAll()),
});

const mapStateToProps = (state) => ({
  filters: state.filters,
  checks: selectChecks(state.checks, state.filters),
  is_verified: state.auth.is_verified,
  labels: state.auth.labels,
  subscriptions: state.plans.subscriptions
    ? state.plans.subscriptions[0].subscription_plan.specifications
    : undefined,
  plan_name: state.plans.subscriptions
    ? state.plans.subscriptions[0].subscription_plan.name
    : undefined,
  email: state.auth.email,
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckList);
